import axios from 'axios';
const api = axios.create({ baseURL: 'https://apidash.smartpress.kz/api' });
api.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
const state = () => ({ requests: [], archivedRequests: [], addModal: false, editModal: false, currentEditingRequest: null, viewModal: false, currentViewingRequest: null });
const getters = {
  requests: s => s.requests, archivedRequests: s => s.archivedRequests,
  addModal: s => s.addModal, editModal: s => s.editModal,
  currentEditingRequest: s => s.currentEditingRequest,
  viewModal: s => s.viewModal, currentViewingRequest: s => s.currentViewingRequest,
};
const mutations = {
  SET_REQUESTS(s, value) { s.requests = value; },
  SET_ARCHIVED_REQUESTS(s, value) { s.archivedRequests = value; },
  UPSERT_REQUEST(s, ticket) {
    if (!ticket) return;
    s.requests = s.requests.filter(item => item.id !== ticket.id && item.status !== 'archived');
    s.archivedRequests = s.archivedRequests.filter(item => item.id !== ticket.id);
    if (ticket.status === 'archived') s.archivedRequests.unshift(ticket);
    else s.requests.unshift(ticket);
    if (s.currentViewingRequest?.id === ticket.id) s.currentViewingRequest = ticket;
    if (s.currentEditingRequest?.id === ticket.id) s.currentEditingRequest = ticket;
  },
  SET_ADD_MODAL(s,v){s.addModal=v;}, SET_EDIT_MODAL(s,v){s.editModal=v;},
  SET_CURRENT_EDITING_REQUEST(s,v){s.currentEditingRequest=v;},
  SET_VIEW_MODAL(s,v){s.viewModal=v;}, SET_CURRENT_VIEWING_REQUEST(s,v){s.currentViewingRequest=v;},
};
const actions = {
  async fetchRequests({ commit }) { const { data } = await api.get('/support'); commit('SET_REQUESTS', data); return data; },
  async fetchArchivedRequests({ commit }) { const { data } = await api.get('/support', { params: { archived: 1 } }); commit('SET_ARCHIVED_REQUESTS', data); return data; },
  async createRequest({ dispatch }, data) { const response = await api.post('/support', data); await dispatch('fetchRequests'); return response.data; },
  async editRequest({ commit, dispatch }, { id, data }) { const response = await api.post(`/edit-request/${id}`, data); commit('UPSERT_REQUEST', response.data.request); await dispatch('fetchRequests'); return response.data; },
  async updateRequest({ commit }, { id, data }) { const response = await api.post(`/support-request/${id}`, data); commit('UPSERT_REQUEST', response.data.request); return response.data; },
  async changeRequestStatus({ commit }, { id, status, comment, response }) {
    const result = await api.patch(`/support/${id}/status`, { status, ...(comment ? { comment } : {}), ...(response ? { response } : {}) });
    commit('UPSERT_REQUEST', result.data.request); return result.data;
  },
  async addComment({ commit }, { id, body }) { const { data } = await api.post(`/support/${id}/comments`, { body }); commit('UPSERT_REQUEST', data.request); return data; },
  async closeRequest({ commit }, id) { const { data } = await api.post(`/support/${id}/close`); commit('UPSERT_REQUEST', data.request); return data; },
  openEditModal({commit}, item){commit('SET_CURRENT_EDITING_REQUEST',item);commit('SET_EDIT_MODAL',true);},
  closeEditModal({commit}){commit('SET_CURRENT_EDITING_REQUEST',null);commit('SET_EDIT_MODAL',false);},
  openSupportRequestModal({commit}){commit('SET_ADD_MODAL',true);},
  closeSupportRequestModal({commit}){commit('SET_ADD_MODAL',false);},
  openViewModal({commit},item){commit('SET_CURRENT_VIEWING_REQUEST',item);commit('SET_VIEW_MODAL',true);},
  closeViewModal({commit}){commit('SET_CURRENT_VIEWING_REQUEST',null);commit('SET_VIEW_MODAL',false);},
};
export default { namespaced:true, state, getters, actions, mutations };